<div class="video-modal">
    <div class="video-modal-body">
        <ng-content></ng-content>
    </div>
</div>
<div class="video-modal-background"></div>